import { MinzeElement } from 'minze'

export type ContentType =
  | 'accueil'
  | 'evenement'
  | 'representation'
  | 'exposition'
  | 'series'
  | 'lieu'
  | 'artiste'
  | 'organisation'
  | 'recherche'
  | 'blogue'
  | 'destination'
  | 'autre'

export const getContentTypeFromUrl = (url: string): ContentType => {
  // Handle absolute URLs by extracting pathname
  let urlToProcess = url
  if (url.includes('://')) {
    try {
      const urlObj = new URL(url)
      urlToProcess = urlObj.pathname
    } catch (e) {
      // If URL parsing fails, fall back to original URL
      urlToProcess = url
    }
  }

  const segments = urlToProcess.split('/').filter(segment => segment)

  // Handle homepage (empty or just language)
  if (segments.length === 0 || (segments.length === 1 && ['fr', 'en'].includes(segments[0]))) {
    return 'accueil'
  }

  // Find the main content type segment (skip language if present)
  const startIndex = ['fr', 'en'].includes(segments[0]) ? 1 : 0
  const contentSegment = segments[startIndex]

  switch (contentSegment) {
    case 'evenement':
    case 'event':
      // Check if there's an additional segment after the event ID
      return segments.length > startIndex + 2 ? 'representation' : 'evenement'

    case 'exposition':
    case 'exhibition':
      return 'exposition'
    case 'series':
    case 'event-series':
      return 'series'

    case 'lieu':
    case 'place':
      return 'lieu'

    case 'artiste':
    case 'artist':
      return 'artiste'

    case 'organisation':
    case 'organization':
      return 'organisation'
    case 'recherche':
    case 'search':
      return 'recherche'
    case 'blogue':
    case 'blog':
      return 'blogue'
    case 'destination':
      return 'destination'
    default:
      return 'autre'
  }
}

export const isEventPageType = (url: string): boolean => {
  const contentType = getContentTypeFromUrl(url)
  return (
    contentType === 'evenement' ||
    contentType === 'representation' ||
    contentType === 'exposition' ||
    contentType === 'series'
  )
}

export const getSlotContent = (el: MinzeElement, slotName: string): string | null => {
  const slot = el.select(`slot[name="${slotName}"]`)
  const assignedNodes = (slot as HTMLSlotElement)?.assignedNodes({ flatten: true }) || []

  // Find the first element or text node and extract its content
  const contentNode = assignedNodes.find(
    node => node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE
  )

  return contentNode instanceof HTMLElement
    ? contentNode.textContent?.trim() || null
    : contentNode?.textContent?.trim() || null
}
